import { MasterData } from "../models/master-data";
import { User } from "./user";

// NOTE: image: クライアントからアップロードする、画像のファイルデータ
// NOTE: image_url: imageをサーバーサイドにアップロードした後に、サーバーサイドで発行される、画像のurl
export class Board {
  id: number;
  reserved_date: string;
  timeframe: string;
  area: string;
  area_detail?: string;
  purpose: string;
  free_text?: string;
  hide_when_matched: boolean;
  image?: File;
  image_url?: string;
  created_at: string;
  user: User;

  constructor(fields: any) {
    for (const f in fields) {
      this[f] = fields[f];
    }
  }

  static MALE_POSTING_LIMIT: number = 3;
  static FEMALE_POSTING_LIMIT: number = 5;

  displayDate(): string {
    let date = new Date(this.reserved_date);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let prefix = this.setDatePrefix(year, month, day);
    return `${prefix} ${month} / ${day}`;
  }

  displayTimeframe(): string {
    let masterData = MasterData.getData();
    return masterData["board_timeframes"][this.timeframe];
  }

  displayArea(): string {
    let masterData = MasterData.getData();
    return masterData["board_areas"][this.area];
  }

  displayPurpose(): string {
    let masterData = MasterData.getData();
    return masterData["board_purposes"][this.purpose];
  }

  getImageUrl(): string {
    return this.image_url;
  }

  getAreaDetail(): string {
    return this.area_detail;
  }

  getFreeText(): string {
    return this.free_text;
  }

  getCreatedAt(): string {
    return this.created_at;
  }

  displayCreatedAt(): string {
    const now: number = new Date().getTime();
    const createdAt: number = Date.parse(this.created_at);
    const diff: number = now - createdAt;
    // ~1分　=> "たった今"
    if (diff < 60000) {
      return "たった今";
    }
    // ~1時間　=> "〇〇分前"
    if (diff < 3600000) {
      const minutes: number = Math.floor(diff / 1000 / 60);
      return minutes + "分前";
    }
    // ~24時間　=> "〇〇時間前"
    if (diff < 86400000) {
      const hours: number = Math.floor(diff / 1000 / 60 / 60);
      return hours + "時間前";
    }
    // 24時間〜　=> "〇〇日前"
    const days: number = Math.floor(diff / 1000 / 60 / 60 / 24);
    return days + "日前";
  }

  private setDatePrefix(year: number, month: number, day: number): string {
    let today = new Date();
    let todayYear = today.getFullYear();
    let todayMonth = today.getMonth() + 1;
    let todayDay = today.getDate();

    if (year === todayYear && month === todayMonth && day === todayDay) {
      return "今日";
    }
    if (year === todayYear && month === todayMonth && day - 1 === todayDay) {
      return "明日";
    }
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/models/board.ts